import { PipeTransform, Pipe } from "@angular/core";

const PADDING = "000000";
@Pipe({ name: "custom-currency" })
export class CustomCurrencyPipe implements PipeTransform {

  private PREFIX: string
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;
  private SUFFIX: string

  constructor() {
    // TODO comes from configuration settings
    this.PREFIX = ''
    this.DECIMAL_SEPARATOR = ",";
    this.THOUSANDS_SEPARATOR = " ";
    this.SUFFIX = ' €'
  }

  transform(value: string, fractionSize: number = 2, decimal_separator: string = this.DECIMAL_SEPARATOR): string {
    if (value != '') {
      let [integer, fraction = ""] = (value || "").toString().split(decimal_separator);

      fraction = fractionSize > 0
        ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
        : "";

      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

      return this.SUFFIX + this.PREFIX + integer + fraction ;
    }
    return null;
  }

  parse(value: string, fractionSize: number = 2, decimal_separator: string = this.DECIMAL_SEPARATOR): string {
    let [integer, fraction = ""] = (value || "").replace(this.PREFIX, "")
      .replace(this.SUFFIX, "")
      .split(decimal_separator);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
      : "";

    return integer + fraction;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/Currency.pipe.ts